(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tjom", [], factory);
	else if(typeof exports === 'object')
		exports["tjom"] = factory();
	else
		root["tjom"] = factory();
})(global, function() {
return 